import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import axios from 'axios';

import { Row, Col, Button, Card, CardHeader, CardFooter, CardBody, Form, FormGroup, Label, Input, Table, Alert } from 'reactstrap';

import * as vars from '../../constants/variables';

import { show, hide } from "../../actions/ActivityIndicatorActions";
import { getDomains } from "../../actions/DomainActions";
import CountryModal from "../CountryModal/CountryModal";

import { console_log, appendUid } from "../../utils/helper";

class Domain extends Component {
    constructor(props) {
        super(props);
        this.state = {
            domainName: '',
            domainUrl: '',
            isValid: false,
            errorMessage: '',
            countryModal: false,
            domainId: 0,
            countries: []
        };
        this.isValid = this.isValid.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.deleteDomain = this.deleteDomain.bind(this);
        this.onChangeEnabled = this.onChangeEnabled.bind(this);
        this._getCountryModalToggle = this._getCountryModalToggle.bind(this);
        this.mapCountryDomain = this.mapCountryDomain.bind(this);
    }

    componentWillMount() {
        this.getDomains();
    }

    componentDidUpdate() {
        if (!this.props.user.isAuthenticated) {
            this.props.history.push(appendUid('/login', this.props.access.uid));
        }
    }

    isValid() {
        let url = new RegExp('^(http:\\/\\/www\\.|https:\\/\\/www\\.|http:\\/\\/|https:\\/\\/)[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$');

        if (this.state.domainName == '') {
            this.setState({
                isValid: false,
                errorMessage: "Domain Name field is required."
            });
            return false;
        }
        if (this.state.domainUrl == '') {
            this.setState({
                isValid: false,
                errorMessage: "Domain URL field is required."
            });
            return false;
        }
        if (!url.test(this.state.domainUrl)) {
            this.setState({
                isValid: false,
                errorMessage: "Domain URL is not valid."
            });
            return false;
        }

        return true;
    }

    onSubmit(e) {
        e.preventDefault();

        if(this.isValid()){
            this.setState({ isValid: true, errorMessage: ''});
            this.addDomain({
                domainName: this.state.domainName,
                url: this.state.domainUrl
            });
        }
    }

    onChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    onKeyUp(e) {
        if (e.keyCode == 13) {
            if (this.isValid()) {
                this.setState({ isValid: true, errorMessage: ''});
                this.addDomain({
                    domainName: this.state.domainName,
                    url: this.state.domainUrl
                });
            }
        }
    }

    addDomain(data) {
        this.props.show();
        axios.post(vars.BASE_URL+'/addDomain', data)
            .then((response) => {
                this.props.hide();
                if (response.data.success) {
                    this.getDomains();
                }
                this.setState({
                    domainName: '',
                    domainUrl: '',
                    isValid: false,
                    errorMessage: '',
                    domainId: 0,
                    countries: []
                })
            })
            .catch((error) => {
                this.props.hide();
                console_log(error);
                this.setState({ isValid: false, errorMessage: 'Sorry, cannot add domain right now, please try again later.'});
            });
    }

    getDomains() {
        this.props.show();
        axios.get(vars.BASE_URL+'/getDomain')
            .then((response) => {
                this.props.hide();
                if (response.data.success) {
                    this.props.getDomains(response.data);
                }
            })
            .catch((error) => {
                this.props.hide();
                console_log(error);
                this.setState({ isValid: false, errorMessage: 'Unable to fetch the data.'});
            });
    }

    deleteDomain(domainId) {
        this.props.show();
        axios.delete(vars.BASE_URL+'/deleteDomain', { data: {'domainId': domainId}})
            .then((response) => {
                this.props.hide();
                if (response.data.success) {
                    this.getDomains();
                }
            })
            .catch((error) => {
                this.props.hide();
                console_log(error);
                this.setState({ isValid: false, errorMessage: 'Sorry, cannot delete domain right now, please try again later.'});
            });
    }

    onChangeEnabled(domain) {
        domain.isEnabled = !domain.isEnabled;
        this.props.show();
        axios.put(vars.BASE_URL+'/setDomain', domain)
            .then((response) => {
                this.props.hide();
                if (response.data.success) {
                    this.getDomains();
                }
            })
            .catch((error) => {
                this.props.hide();
                console_log(error);
                this.setState({ isValid: false, errorMessage: 'Sorry, cannot update domain right now, please try again later.'});
            });
    }

    _getCountryModalToggle(domain) {
        this.setState({
            countryModal: !this.state.countryModal,
            domainId: domain.domainId,
            countries: domain.countries
        });
    }

    mapCountryDomain(data) {
        this.props.show();
        axios.post(vars.BASE_URL+'/mapCountriesToDomain', data)
            .then((response) => {
                this.props.hide();
                if (response.data.success) {
                    this.getDomains();
                }
            })
            .catch((error) => {
                this.props.hide();
                console_log(error);
                this.setState({ isValid: false, errorMessage: 'Sorry, cannot map country to domain right now, please try again later.'});
            });
    }

    render() {
        return (
            <div className="domain animated fadeIn">
                <Row>
                    <Col xs="12" md="12">
                        <Card>
                            <CardHeader>
                                <strong>Add Domain</strong>
                            </CardHeader>
                            <CardBody>
                                <Form action="" method="post" encType="multipart/form-data" className="form-horizontal">
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="domainName">Domain Name</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            <Input type="text" id="domainName" name="domainName" placeholder="Domain Name" value={this.state.domainName} onChange={this.onChange} onKeyUp={this.onKeyUp} />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="domainUrl">URL</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            <Input type="text" id="domainUrl" name="domainUrl" placeholder="URL (Ex. http://game-lords.com)" value={this.state.domainUrl} onChange={this.onChange} onKeyUp={this.onKeyUp}/>
                                        </Col>
                                    </FormGroup>
                                    {(!this.state.isValid && this.state.errorMessage != '') ?
                                        <Alert color="danger">{this.state.errorMessage}</Alert> : ''}
                                </Form>
                            </CardBody>
                            <CardFooter className="card-footer-align-right">
                                <Button type="submit" color="primary" onClick={this.onSubmit}><i className="fa fa-check"></i> Add</Button>
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <Table hover responsive size="lg" className="domain-custom-table">
                                    <thead>
                                        <tr>
                                            <th>Domain</th>
                                            <th>URL</th>
                                            <th>Country</th>
                                            <th>Enabled</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(this.props.domains.domains.length > 0) ? this.props.domains.domains.map((v, k) => {
                                            return (
                                                <tr key={k}>
                                                    <td><strong>{v.domainName}</strong></td>
                                                    <td>{v.url}</td>
                                                    <td>
                                                        {(v.countryData.length > 0) ?
                                                            v.countryData.map((country, i) => {
                                                                return <span key={i} className="gray-highlight"> {country.countryCode} </span>
                                                            }) : ''
                                                        }
                                                    </td>
                                                    <td>
                                                        <Label className="switch switch-text switch-pill switch-success">
                                                            <Input type="checkbox" className="switch-input" checked={ v.isEnabled ? true: false} onChange={this.onChangeEnabled.bind(this, { 'domainId': v.domainId, 'isEnabled': v.isEnabled })}/>
                                                            <span className="switch-label" data-on="On" data-off="Off"></span>
                                                            <span className="switch-handle"></span>
                                                        </Label>
                                                    </td>
                                                    <td>
                                                        <Button size="sm" color="success" onClick={this._getCountryModalToggle.bind(this, {'domainId': v.domainId, 'countries': v.countryData.map((v) => v.countryId)})}>
                                                            <i className="fa fa-edit"></i>
                                                        </Button>
                                                        <Button size="sm" color="danger" onClick={this.deleteDomain.bind(this, v.domainId)}>
                                                            <i className="fa fa-trash"></i>
                                                        </Button>
                                                    </td>
                                                </tr>
                                            )
                                        }): <tr>
                                                <td rowSpan={5}>
                                                    No Domains Added Yet.
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <CountryModal show={this.state.countryModal} countries={this.state.countries} domainId={this.state.domainId} modalToggle={this._getCountryModalToggle} mapCountryDomain={this.mapCountryDomain}/>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.AuthenticationReducer,
        access: state.WelcomeReducer,
        domains: state.DomainReducer,
        country: state.CountryReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        show,
        hide,
        getDomains
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Domain);


// WEBPACK FOOTER //
// ./src/components/Domain/Domain.js